'use strict';

import ProductImage from './components/ProductImage.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('product-image', ProductImage);

    }
}